import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom-v5-compat';
import { useRegisterUserMutation } from 'src/graphql';
import {
  ACCOUNT_ACTIVATION_SOURCE,
  REPORTING_ACCOUNT_ACTIVATION_STEP,
  trackAccountActivation,
} from 'src/utils/analytics/track/reporting';
import {
  ChangePasswordNewCommon,
  FormValues,
} from '../../ChangePasswordNew/ChangePasswordNewCommon';
import { LoginContainer } from '../ReportingLoginContainer/ReportingLoginContainer';
import { ReportingResetResult } from '../ReportingResetResult/ReportingResetResult';
import { Description, FormContainer, Header } from './ReportingReset.styles';

export const ReportingReset = () => {
  const { t } = useTranslation();
  const { token } = useParams<{ token: string }>();
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);
  const registerAccount = useRegisterUserMutation({
    onSettled() {
      setHasSubmitted(true);
    },
  });

  const createPassword = async (data: FormValues) => {
    const { newPassword } = data;

    if (token) {
      registerAccount.mutate({
        token,
        password: newPassword,
      });
    }
  };

  const hasTracked = useRef(false);

  useEffect(() => {
    if (!hasTracked.current && token) {
      trackAccountActivation({
        step_description:
          REPORTING_ACCOUNT_ACTIVATION_STEP.EMAIL_MAGIC_LINK_CLICK,
        source: ACCOUNT_ACTIVATION_SOURCE.USER_PORTAL,
      });
      hasTracked.current = true;
    }
  }, [token]);

  return (
    <>
      {hasSubmitted ? (
        <ReportingResetResult isSuccess={registerAccount.isSuccess} />
      ) : (
        <LoginContainer data-testid="reset">
          <Header>{t('Buttons.signUp')}</Header>
          <Description>{t('public.Password.newDescription')}</Description>
          <FormContainer>
            <ChangePasswordNewCommon
              createPassword={createPassword}
              updateWithToken={true}
              isLoading={false}
              buttonText={t('Buttons.signUp')}
              isLocalised={true}
              data-testid="register"
            />
          </FormContainer>
        </LoginContainer>
      )}
    </>
  );
};
